var map = {
	"./baochang.svg": "6e21",
	"./pad_icon1.svg": "d200",
	"./pad_icon2.svg": "3f95",
	"./pad_icon3.svg": "ced3",
	"./pad_icon4.svg": "fb56",
	"./pad_icon5.svg": "5a33",
	"./pad_icon6.svg": "e5a7",
	"./pad_icon7.svg": "3df9",
	"./pad_icon8.svg": "707b",
	"./pad_icon9.svg": "94c6",
	"./vipbtn.svg": "a386"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eae1";